import React from 'react';
import { useAudio } from '../../providers/AudioContext';
import { StyledIconButton } from './IconButton.styled';

const IconButton = ({
  children,
  onClick,
  animated = true,
  disabled = false,
  backgroundOverwrite = null,
  backgroundOverwriteHover = null,
  borderOverwrite = null,
  borderOverwriteHover = null,
  rows = 1,
  clickSound = 'button',
  responsive = false
}) => {
  const { playSFX } = useAudio();
  const onButtonClick = () => {
    if (disabled) return;
    playSFX(clickSound);
    onClick();
  };
  return (
    <StyledIconButton className={responsive ? 'icon-button-wrapper-responsive':''} onClick={onButtonClick} $disabled={disabled} $animated={animated} $backgroundOverwrite={backgroundOverwrite} $backgroundOverwriteHover={backgroundOverwriteHover} $borderOverwrite={borderOverwrite} $borderOverwriteHover={borderOverwriteHover} $rows={rows} onMouseEnter={() => disabled ? false : playSFX('hover')}>
      <button className={'icon-button' + (responsive ? ' icon-button-responsive' : '')} >
        {children}
      </button>
      <div className='icon-button-corner icon-button-corner-l' />
      <div className='icon-button-corner icon-button-corner-r' />
    </StyledIconButton>
  )
};

export default IconButton;

